import { OptionType, ProviderFacetGroups, ProviderFilterGroups } from './types';

export const FILTER_CURRENT_LOCATION = 'Current Location';

export const INSURANCE_SH_PAYER_NAME = 'SelectHealth';
export const INSURANCE_SOURCE_MILLENNIUM = 'Millennium';
export const INSURANCE_SOURCE_SELECT_HEALTH = 'Facets';

export const START_PAGE_NUMBER = 0;

export const BEST_MATCH_NUMBER = 3;

export const ID_TYPE_CORPPROV = 'corpprovid';

export const GENDER_OPTIONS: OptionType[] = [
  { label: 'Any', value: '' },
  { label: 'Female', value: 'F' },
  { label: 'Male', value: 'M' }
];

export const PROVIDER_TYPE_OPTIONS: OptionType[] = [
  { label: 'MD', value: 'MD' },
  { label: 'DO', value: 'DO' },
  { label: 'NP', value: 'NP' },
  { label: 'PA', value: 'PA' }
];

export const PRACTICE_YEAR_OPTIONS: OptionType[] = [
  { label: '5+', value: '5' },
  { label: '10+', value: '10' },
  { label: '15+', value: '15' },
  { label: '20+', value: '20' },
  { label: '25+', value: '25' }
];

export const SORT_BY_BEST_MATCH: OptionType = { label: 'Top Match', value: 'bestMatch' };
export const SORT_BY_PROXIMITY: OptionType = { label: 'Proximity', value: 'proximity' };
export const SORT_BY_HIGHEST_RATING: OptionType = { label: 'Highest Rating', value: 'rating' };
export const SORT_BY_LAST_NAME: OptionType = { label: 'Last Name', value: 'lastName' };

export const SORT_OPTIONS: OptionType[] = [
  SORT_BY_BEST_MATCH,
  SORT_BY_PROXIMITY,
  SORT_BY_HIGHEST_RATING,
  SORT_BY_LAST_NAME
];

export const SORT_OPTIONS_NO_TC: OptionType[] = [
  SORT_BY_LAST_NAME,
  SORT_BY_PROXIMITY,
  SORT_BY_HIGHEST_RATING
];

export const SEARCH_PLACEHOLDER_TEXT = 'Provider name, specialty, or clinic name';
export const SEARCH_LOCATION_PLACEHOLDER_TEXT = 'Near address, city, zip code';
export const noOptionsText = 'No results found. Please update your search criteria and try again.';
export const searchUrl = '/u/find-a-doctor';
export const dateFormat = 'MM/DD/YYYY';
export const specialtiesSubTitle =
  'Select specialties from the list that match your medical concerns';
export enum GroupType {
  Provider = 'Provider',
  Specialty = 'specialty'
}
export const SEARCH_COMMON_SEARCH_TERMS = [
  {
    id: 1,
    label: 'Family Medicine',
    value: 'Family Medicine'
  },
  {
    id: 2,
    label: 'Internal Medicine',
    value: 'Internal Medicine'
  },
  {
    id: 3,
    label: 'Ob/gyn',
    value: 'Obstetrics and Gynecology'
  },
  {
    id: 4,
    label: 'Orthopedic Surgery',
    value: 'Orthopedic Surgery'
  },
  {
    id: 5,
    label: 'Dermatology',
    value: 'Dermatology'
  },
  {
    id: 6,
    label: 'Pediatrics',
    value: 'Pediatrics'
  },
  {
    id: 7,
    label: 'Gastroenterology',
    value: 'Gastroenterology'
  },
  {
    id: 8,
    label: 'Urology',
    value: 'Urology'
  },
  {
    id: 9,
    label: 'Neurology',
    value: 'Neurology'
  }
];

export const FindADoctorBanner = 'Find a Doctor or Specialist';

export const filterStructure = {
  availability: {
    name: 'Availability',
    values: {
      insuranceAliasValues: {
        name: 'Accepts My Insurance',
        group: ProviderFacetGroups.insuranceAliasValues,
        value: true
      },
      acceptsNewPatients: {
        name: 'Accepts New Patients',
        group: ProviderFilterGroups.acceptingNewPatients,
        value: true
      },
      offeringOnlineBooking: {
        name: 'Offers Online Booking',
        group: ProviderFilterGroups.offersOnlineBooking,
        value: true
      },
      acceptsChildren: {
        name: 'Sees Children',
        group: ProviderFilterGroups.acceptsChildren,
        value: true
      }
    }
  },
  locationNearMe: {
    name: 'Location Near Me',
    values: {
      any: {
        name: 'Any',
        group: ProviderFacetGroups.locationDistance,
        value: 9999
      },
      fiveMiles: {
        name: '5 mi',
        group: ProviderFacetGroups.locationDistance,
        value: 5
      },
      tenMiles: {
        name: '10 mi',
        group: ProviderFacetGroups.locationDistance,
        value: 10
      },
      twentyFiveMiles: {
        name: '25 mi',
        group: ProviderFacetGroups.locationDistance,
        value: 25
      }
    }
  },
  gender: {
    name: "Doctor's Gender",
    values: {
      female: {
        name: 'Female',
        group: ProviderFacetGroups.gender,
        value: 'F'
      },
      male: {
        name: 'Male',
        group: ProviderFacetGroups.gender,
        value: 'M'
      }
    }
  },
  display: {
    name: 'Display',
    values: {
      hasPhoto: {
        name: 'Has Photo',
        group: ProviderFilterGroups.hasPhoto,
        value: true
      },
      hasVideo: {
        name: 'Has Video',
        group: ProviderFilterGroups.hasAboutVideo,
        value: true
      }
    }
  },
  affiliations: {
    name: 'Affiliations',
    values: {
      isStLukes: {
        name: "St. Luke's",
        group: ProviderFilterGroups.isStLukes,
        value: true
      },
      isMyHealth: {
        name: 'MyHealth',
        group: ProviderFilterGroups.isMyHealth,
        value: true
      },
      isMedicalGroup: {
        name: 'Intermountain Health Medical Group',
        group: ProviderFilterGroups.isMedicalGroup,
        value: true
      }
    }
  }
};

export const filteredTextKey = {
  isMedicalGroup: 'Intermountain Health Medical Group',
  isMyHealth: 'MyHealth',
  isStLukes: "St. Luke's",
  hasPhoto: 'Has Photo',
  hasAboutVideo: 'Has Video',
  acceptsChildren: 'Sees Children',
  acceptingNewPatients: 'Accepts New Patients',
  offersOnlineBooking: 'Offers Online Booking',
  offersVideoVisits: 'Offering Online Visits'
};
